module.exports = __webpack_public_path__ + "public/img/惊瑜科技@1x.bdb7b402.png";